import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'src',
  pure: false
})
export class SrcPipe implements PipeTransform {
  constructor() {}

  filepath = environment.allegati.filePath;

  transform(value: any,
            formato: 'landscape_4_3_desktop' |
                     'landscape_16_9_desktop' |
                     'portrait_4_3_desktop' |
                     'portrait_16_9_desktop' |
                     'landscape_4_3_mobile' |
                     'landscape_16_9_mobile' |
                     'portrait_4_3_mobile' |
                     'portrait_16_9_mobile' = 'landscape_4_3_desktop'): string {

    const estensione = value.split('.').pop();
    return this.filepath + value.replace('.' + estensione, '_' + formato + '.' + estensione);
  }
}
